import { render, staticRenderFns } from "./merge-radish-dialog.vue?vue&type=template&id=41506ff0&scoped=true"
import script from "./merge-radish-dialog.vue?vue&type=script&lang=js"
export * from "./merge-radish-dialog.vue?vue&type=script&lang=js"
import style0 from "./merge-radish-dialog.vue?vue&type=style&index=0&id=41506ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41506ff0",
  null
  
)

export default component.exports